import { css } from '@/styled-system/css';

export const subGroupCard = css({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '8px',
  padding: '2x',
});

export const subGroupsContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  marginTop: '2x',
});

export const subGroupTitle = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontSize: 'md',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  marginTop: 0,
  marginBottom: '1x',
});

export const subGroupIcon = css({
  flexShrink: 0,
  color: 'hpxTeal500',
});

export const amenityList = css({
  listStyleType: 'disc',
  paddingLeft: '2x',
  margin: 0,
});

export const amenityItem = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  lineHeight: '1.5',
});

export const headerRight = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
});

export const spokeContainer = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: '100%',
  width: '100%',
});

export const footerButtonGroup = css({
  display: 'flex',
  gap: '1x',
  flexWrap: 'wrap',
  width: '100%',
  maxWidth: '400px',
  '& > *': {
    flex: 1,
  },
});

export const spokeContentContainer = css({
  py: '2x',
});

export const leaseTermsText = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  lineHeight: '1.5',
});

export const policyList = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
  listStyleType: 'none',
  padding: 0,
  margin: 0,
});

export const policyRowInner = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const policyValue = css({
  fontWeight: '700',
  color: 'hpxBlue600',
});
